(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cws-portfolio-slider"] && !Shopify.designMode) return;
  try {
    
class CwsPortfolioSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.cws-portfolio-slider__track');
    this.slides = Array.from(this.querySelectorAll('.cws-portfolio-slider__slide'));
    this.prevBtn = this.querySelector('[data-cws-prev]');
    this.nextBtn = this.querySelector('[data-cws-next]');
    this.dots = Array.from(this.querySelectorAll('[data-cws-dot]'));
    this.currentIndex = 0;
    this.autoplayTimer = null;
    this.autoplay = this.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 5000;

    if (!this.track || this.slides.length === 0) return;

    this.onPrevClick = () => this.go(this.currentIndex - 1);
    this.onNextClick = () => this.go(this.currentIndex + 1);
    this.onTrackScroll = () => this.onScroll();
    this.onMouseEnter = () => this.stopAutoplay();
    this.onMouseLeave = () => this.startAutoplay();

    if (this.prevBtn) this.prevBtn.addEventListener('click', this.onPrevClick);
    if (this.nextBtn) this.nextBtn.addEventListener('click', this.onNextClick);
    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => this.go(parseInt(dot.dataset.index, 10)));
    });

    this.track.addEventListener('scroll', this.onTrackScroll, { passive: true });

    if (this.autoplay) {
      this.startAutoplay();
      this.addEventListener('mouseenter', this.onMouseEnter);
      this.addEventListener('mouseleave', this.onMouseLeave);
    }

    this.updateDots(0);
    this.initLightbox();
  }

  disconnectedCallback() {
    this.stopAutoplay();
    if (this.cleanupLightbox) this.cleanupLightbox();
  }

  go(index) {
    var max = this.slides.length - 1;
    if (index < 0) index = max;
    if (index > max) index = 0;
    var slide = this.slides[index];
    this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
    this.currentIndex = index;
    this.updateDots(index);
  }

  onScroll() {
    var trackLeft = this.track.scrollLeft;
    var closest = 0;
    var closestDist = Infinity;
    this.slides.forEach((slide, i) => {
      var dist = Math.abs(slide.offsetLeft - this.track.offsetLeft - trackLeft);
      if (dist < closestDist) {
        closestDist = dist;
        closest = i;
      }
    });
    if (closest !== this.currentIndex) {
      this.currentIndex = closest;
      this.updateDots(closest);
    }
  }

  updateDots(index) {
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === index);
    });
  }

  startAutoplay() {
    this.stopAutoplay();
    this.autoplayTimer = setInterval(() => this.go(this.currentIndex + 1), this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.autoplayTimer) clearInterval(this.autoplayTimer);
  }

  initLightbox() {
    const dialog = this.querySelector('[data-cws-lightbox]');
    if (!dialog) return;

    const viewport = dialog.querySelector('[data-cws-viewport]');
    const targetImg = dialog.querySelector('[data-cws-target-img]');
    const closeBtn = dialog.querySelector('[data-cws-close]');
    const zoomInBtn = dialog.querySelector('[data-cws-zoom-in]');
    const zoomOutBtn = dialog.querySelector('[data-cws-zoom-out]');
    const zoomResetBtn = dialog.querySelector('[data-cws-zoom-reset]');
    const triggers = this.querySelectorAll('[data-lightbox-trigger]');

    let scale = 1;
    let baseWidth = 0;
    let isDragging = false;
    let startX = 0, startY = 0;
    let scrollStartLeft = 0, scrollStartTop = 0;

    const applyScale = (newScale, center = true) => {
      scale = Math.min(Math.max(newScale, 1), 3.5);

      if (scale === 1) {
        targetImg.classList.remove('is-zoomed');
        targetImg.style.width = '';
        viewport.scrollLeft = 0;
        viewport.scrollTop = 0;
      } else {
        if (!baseWidth) {
          baseWidth = targetImg.getBoundingClientRect().width || (window.innerWidth * 0.9);
        }
        targetImg.classList.add('is-zoomed');
        targetImg.style.width = `${Math.round(baseWidth * scale)}px`;

        if (center) {
          requestAnimationFrame(() => {
            viewport.scrollLeft = (viewport.scrollWidth - viewport.clientWidth) / 2;
            viewport.scrollTop = (viewport.scrollHeight - viewport.clientHeight) / 2;
          });
        }
      }

      if (zoomResetBtn) {
        zoomResetBtn.textContent = `${Math.round(scale * 100)}%`;
      }
    };

    const openLightbox = (url, alt) => {
      if (!url) return;
      this.stopAutoplay();
      baseWidth = 0;
      scale = 1;
      targetImg.classList.remove('is-zoomed');
      targetImg.style.width = '';
      targetImg.src = url;
      targetImg.alt = alt || '';
      if (zoomResetBtn) zoomResetBtn.textContent = '100%';

      targetImg.onload = () => {
        baseWidth = targetImg.getBoundingClientRect().width;
      };

      dialog.showModal();
      document.body.style.overflow = 'hidden';
    };

    const closeLightbox = () => {
      dialog.close();
      targetImg.src = '';
      targetImg.classList.remove('is-zoomed');
      targetImg.style.width = '';
      scale = 1;
      baseWidth = 0;
      document.body.style.overflow = '';
      if (this.autoplay) this.startAutoplay();
    };

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        openLightbox(trigger.dataset.fullImg, trigger.dataset.alt);
      });
      trigger.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          trigger.click();
        }
      });
    });

    closeBtn.addEventListener('click', closeLightbox);
    dialog.addEventListener('cancel', closeLightbox);

    zoomInBtn.addEventListener('click', () => applyScale(scale + 0.5));
    zoomOutBtn.addEventListener('click', () => applyScale(scale - 0.5));
    zoomResetBtn.addEventListener('click', () => applyScale(1));

    targetImg.addEventListener('click', (e) => {
      e.stopPropagation();
      applyScale(scale > 1.1 ? 1 : 2.2);
    });

    viewport.addEventListener('wheel', (e) => {
      if (!e.ctrlKey && scale === 1) return;
      e.preventDefault();
      applyScale(scale + (e.deltaY < 0 ? 0.25 : -0.25), false);
    }, { passive: false });

    // Drag-and-drop con mouse su desktop
    viewport.addEventListener('mousedown', (e) => {
      if (e.target === closeBtn || e.target.closest('.cws-portfolio-lightbox__bar')) return;
      isDragging = true;
      viewport.classList.add('is-dragging');
      startX = e.pageX - viewport.offsetLeft;
      startY = e.pageY - viewport.offsetTop;
      scrollStartLeft = viewport.scrollLeft;
      scrollStartTop = viewport.scrollTop;
    });

    window.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      e.preventDefault();
      const x = e.pageX - viewport.offsetLeft;
      const y = e.pageY - viewport.offsetTop;
      viewport.scrollLeft = scrollStartLeft - (x - startX) * 1.5;
      viewport.scrollTop = scrollStartTop - (y - startY) * 1.5;
    });

    window.addEventListener('mouseup', () => {
      isDragging = false;
      viewport.classList.remove('is-dragging');
    });

    viewport.addEventListener('click', (e) => {
      if (e.target === viewport || e.target.classList.contains('cws-portfolio-lightbox__canvas')) {
        closeLightbox();
      }
    });

    this.cleanupLightbox = () => {
      document.body.style.overflow = '';
    };
  }
}

if (!customElements.get('cws-portfolio-slider')) {
  customElements.define('cws-portfolio-slider', CwsPortfolioSlider);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
